import Phaser from 'phaser';

// Centralized input mapping: keyboard + optional gamepad, exposed as a
// simple polled state object so entities don't touch Phaser's input API directly.
//
// Note: Phaser's kb.addKeys() only accepts one key code per property — it
// does NOT support comma-joined codes like 'LEFT,A' as a single binding.
// Each physical key is bound separately below and combined with OR logic.

const Codes = Phaser.Input.Keyboard.KeyCodes;

export class InputController {
  constructor(scene) {
    this.scene = scene;
    const kb = scene.input.keyboard;

    this.keys = {
      left: kb.addKey(Codes.LEFT),
      a: kb.addKey(Codes.A),
      right: kb.addKey(Codes.RIGHT),
      d: kb.addKey(Codes.D),
      up: kb.addKey(Codes.UP),
      w: kb.addKey(Codes.W),
      space: kb.addKey(Codes.SPACE),
      shootJ: kb.addKey(Codes.J),
      shootZ: kb.addKey(Codes.Z),
      pause: kb.addKey(Codes.ESC)
    };

    this.state = {
      moveX: 0,
      jumpDown: false,
      jumpPressed: false,
      shootDown: false,
      pausePressed: false
    };

    this._prevJump = false;
    this._prevPause = false;
  }

  update() {
    const pad = this.scene.input.gamepad?.getPad(0);
    const k = this.keys;

    let moveX = 0;
    if (k.left.isDown || k.a.isDown) moveX -= 1;
    if (k.right.isDown || k.d.isDown) moveX += 1;

    let jumpDown = k.space.isDown || k.up.isDown || k.w.isDown;
    let shootDown = k.shootJ.isDown || k.shootZ.isDown;
    let pauseDown = k.pause.isDown;

    if (pad) {
      const axisX = pad.axes.length ? pad.axes[0].getValue() : 0;
      if (Math.abs(axisX) > 0.2) moveX = axisX > 0 ? 1 : -1;
      if (pad.left) moveX = -1;
      if (pad.right) moveX = 1;
      if (pad.A) jumpDown = jumpDown || pad.A;
      if (pad.X) shootDown = shootDown || pad.X;
    }

    this.state.moveX = moveX;
    this.state.jumpDown = jumpDown;
    this.state.jumpPressed = jumpDown && !this._prevJump;
    this.state.shootDown = shootDown;
    this.state.pausePressed = pauseDown && !this._prevPause;

    this._prevJump = jumpDown;
    this._prevPause = pauseDown;
  }
}
